
import { defineComponent, ref, getCurrentInstance, computed } from 'vue';
import ActionSheet from 'vant/lib/action-sheet';

// import { Button } from 'vant';

enum PraiseAmount {
  lowAmount = "0.01",
  mediumAmount = "0.05",
  highAmount = "0.1"
}

export default defineComponent({
  components: {
    vanActionSheet: ActionSheet,
    // vanButton: Button
  },
  setup(_, context) {
    const { proxy } = getCurrentInstance() as { proxy: any }
    const amountList = proxy.$store.state.tgPraiseAmountList
    const lowPraiseTitle = amountList.length > 0? amountList[0]: `${PraiseAmount.lowAmount}`
    const mediumPraiseTitle = amountList.length > 1? amountList[1]: `${PraiseAmount.mediumAmount}`
    const highPraiseTitle = amountList.length > 2? amountList[2]: `${PraiseAmount.highAmount}`
    const show = ref(true)
    const selectedAmount = ref(lowPraiseTitle)
    const lowAmountSelected = ref(true)
    const mediumAmountSelected = ref(false)
    const highAmountSelected = ref(false)

    const titleWords = computed(() => {
      return proxy.$root.$t('k_1218783').replace('${0}', proxy.$appName)
    })
    const installWords = computed(() => {
      return  proxy.$root.$t('k_1218782').replace('${0}', proxy.$appName) + '$' + selectedAmount.value
    })
    const handleConfirm = () => {
      context.emit('confirm', { button_type: 'main', pay_amount: selectedAmount.value, skip_to: 'app', money: selectedAmount.value });
    };
    
    const handleClose = ({ button_type }: Record<string, string>) => {
      show.value = false;
      setTimeout(() => {
        context.emit('close', { button_type });
      }, 500);
    };
    const handleButtonClick = (amount: PraiseAmount) => {
      if (amount === PraiseAmount.lowAmount) {
        selectedAmount.value = lowPraiseTitle
      } else if (amount === PraiseAmount.mediumAmount) {
        selectedAmount.value = mediumPraiseTitle
      } else {
        selectedAmount.value = highPraiseTitle
      }
      lowAmountSelected.value = (amount === PraiseAmount.lowAmount)
      mediumAmountSelected.value = (amount === PraiseAmount.mediumAmount)
      highAmountSelected.value = (amount === PraiseAmount.highAmount)
      console.log("praise-vai-tel-wallet" + "amountList:" + amountList.length)
    }
    
    return {
      lowAmountSelected,
      mediumAmountSelected,
      highAmountSelected,
      lowPraiseTitle,
      mediumPraiseTitle,
      highPraiseTitle,
      show,
      installWords,
      titleWords,
      selectedAmount,
      handleClose,
      handleConfirm,
      handleButtonClick,
      PraiseAmount,
      amountList,
    };
  },
});
